import { Module } from 'vuex';
import { NodeTypeState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeTypeState = {
    normalNodeIndex: {
        list: undefined,
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    simpleNodeIndex: {
        list: undefined,
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const nodeType: Module<NodeTypeState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
